const API_BASE = '/api/public';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...options?.headers },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data as T;
}

export const api = {
  getPlans: () => request<{ id: number; name: string; price_monthly: number; max_users: number; max_properties: number; modules: string[] }[]>('/plans'),
  sendVerifyCode: (email: string) => request<{ success: boolean }>('/email-verify/send', { method: 'POST', body: JSON.stringify({ email }) }),
  confirmVerifyCode: (email: string, code: string) => request<{ verified: boolean }>('/email-verify/confirm', { method: 'POST', body: JSON.stringify({ email, code }) }),
  registerTrial: (data: Record<string, unknown>) => request<{ success: boolean }>('/trial/register', { method: 'POST', body: JSON.stringify(data) }),
  submitContact: (data: Record<string, string>) => request<{ success: boolean }>('/contact', { method: 'POST', body: JSON.stringify(data) }),
  submitLead: (data: Record<string, unknown>) => request<{ success: boolean }>('/leads', { method: 'POST', body: JSON.stringify(data) }),
  verifyLeadToken: (token: string) => request<{ name: string; email: string; company_name: string; plan_name: string | null; price_monthly: number | null }>(`/lead-setup/verify?token=${token}`),
  completeLeadSetup: (data: Record<string, unknown>) => request<{ accessToken: string; tenant: { slug: string } }>('/lead-setup/complete', { method: 'POST', body: JSON.stringify(data) }),
};
